import axios from 'axios';
import CompetingFirm from '../entity/competing-firm.entity';

export default class CompetingFirmService {
  static readonly PATH_URL = '/api/v1/competing-firms';

  public static getCompetingFirms(): Promise<CompetingFirm[]> {
    return axios.get(this.PATH_URL)
      .then((response: any) => CompetingFirm.ofList(response.data));
  }

  public static create(competingFirm: CompetingFirm): Promise<CompetingFirm> {
    return axios
      .post(this.PATH_URL, competingFirm)
      .then((response: any) => CompetingFirm.of(response.data));
  }
}
